<ng-content select="[input]"></ng-content>